import React from 'react';

import { Link } from 'gatsby';

import './MainFooter.css';

const mainFooter = props => (

    <footer className="main-footer">
        <div />
        <nav className="main-footer__items">
            <ul>
                <li><Link to="/impressum">Impressum</Link></li>
                <li><Link to="/datenschutz">Datenschutz</Link></li>
                <li><Link to="/ueber-uns">Über</Link></li>
            </ul>
        </nav>
    </footer>
    
);

export default mainFooter;